import { twMerge } from 'tailwind-merge';
import { EventAddLike } from '@generated/events';
import { Button } from '../Clickables/Buttons/Button';
import { LikeIcon } from '../Icons/LikeIcon';

export type LikeType = EventAddLike['properties']['object_type'];

type LabelPosition = 'right' | 'bottom';

interface IProps {
  className?: string;
  hideNumber?: boolean;
  iconSize?: number;
  isLiked: boolean;
  labelPosition?: LabelPosition;
  likesInfoClassName?: string;
  numberOfLikes: number;
  onLikesButtonClick?: () => void;
  onLikesInfoClick?: () => void;
  onlyNumber?: boolean;
  onNotLoggedIn?: () => void;
  type: LikeType;
}

const getLikesString = (count: number): string => (count === 1 ? '1 like' : `${count} likes`);

export const LikeButton = ({
  className,
  hideNumber,
  iconSize,
  isLiked,
  labelPosition = 'right',
  likesInfoClassName,
  numberOfLikes,
  onLikesButtonClick,
  onLikesInfoClick,
  onlyNumber,
}: IProps) => {
  const handleButtonClick = (): void => {
    if (onLikesButtonClick) {
      onLikesButtonClick();
    }
  };

  return (
    <div
      className={twMerge(
        'flex',
        !hideNumber && labelPosition === 'right' ? 'items-center' : 'flex-col',
        className,
      )}
    >
      <Button
        variant="textPrimary"
        onClick={handleButtonClick}
        style={{ outline: 'none' }}
        data-testid="LikeButton"
      >
        <div
          className={twMerge(
            'flex justify-start',
            !hideNumber && (labelPosition === 'right' ? 'mr-3' : 'mb-3'),
          )}
        >
          <LikeIcon title="like button icon" size={iconSize} isLiked={isLiked} />
        </div>
      </Button>
      {!hideNumber && (
        <Button
          className={twMerge('p-0!', likesInfoClassName)}
          onClick={onLikesInfoClick}
          variant="buttonNone"
        >
          {onlyNumber ? numberOfLikes : getLikesString(numberOfLikes)}
        </Button>
      )}
    </div>
  );
};
